import { Box, Typography } from "@mui/material";
import FormField from "../common/FormField";
import { useEffect, useState } from "react";
import { useFormContext, useWatch } from "react-hook-form";
let DisplayOption =
  [
    { value: true, label: 'Yes' },
    { value: false, label: 'No' }
  ];

const FbSectionPropertyTab = ({ selectedSection }) => {
  const [sectionId, setSectionId] = useState(0);
  const {control}=useFormContext()
  const sectionSchema = useWatch({control, name: 'sections' });

  useEffect(() => {
    const sectionIndex = sectionSchema.findIndex(section => section?.section_uuid === selectedSection);
    setSectionId(sectionIndex === -1 ? 0 : sectionIndex);
  }, [sectionSchema, selectedSection, setSectionId])

  return (
    <Box className="bg-white rounded-2xl h-full border-[0.11rem] border-white">
      <div className="h-[49px] bg-[#E8EFFC] gap-[25px] p-[15px] rounded-tl-[10px] rounded-tr-[10px]">
        <Typography variant="h6" fontWeight="500">
          Properties Tab
        </Typography>
      </div>

      <div className="mx-3 pt-2 pb-2 border-b border-gray-300">
        <Typography className="text-black">
          {sectionId + 1}. {sectionSchema[sectionId]?.name || "Section Name"}
        </Typography>
      </div>
      <Box className="p-2 pt-2 mx-2 font-medium" key={`section-${sectionId}`}>
        <Typography variant="subtitle1" fontWeight="500">
          Display Field Number
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          mb={1}
          fontWeight="400"
        >
          Determines display of the field reference number.
        </Typography>

        <FormField
          name={`sections[${sectionId}].property.display_field_number`}
          type="radio-group"
          options={DisplayOption}
          row="row"
        />
      </Box>
    </Box>
  );
};
export default FbSectionPropertyTab;